var _g, _g2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 65,
    viewBox: "0 0 66 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Untitled design (7) 1",
    clipPath: "url(#clip0_5267_39210)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5267_39210",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 19,
    width: 65,
    height: 46
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e6a4049efd"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.900391 19.0938H64.6139V65H0.900391V19.0938Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5267_39210)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M62.1863 19.1197H55.6759V24.2151H59.163L55.3818 56.3551C55.2294 57.6415 54.1404 58.6101 52.8459 58.6101C51.5515 58.6101 50.4652 57.6442 50.3102 56.3604L47.1623 30.128C46.9318 28.2069 45.3022 26.7614 43.3678 26.7614H16.1841C15.4806 26.7614 14.9096 26.1905 14.9096 25.487C14.9096 24.7834 15.4806 24.2125 16.1841 24.2125H22.1289L21.8122 22.31C21.5049 20.467 19.9097 19.1171 18.0417 19.1171H4.50019C2.5102 19.1171 0.896484 20.7306 0.896484 22.7206C0.896484 22.865 0.905653 23.0108 0.922933 23.1538L5.31357 59.3732C5.70043 62.5714 8.41511 64.9761 11.6372 64.9761H53.8329C57.063 64.9761 59.7816 62.5581 60.1593 59.3506L64.5763 21.8025C64.5869 21.7085 64.5922 21.6158 64.5922 21.5216C64.5922 20.1928 63.5152 19.1143 62.185 19.1143L62.1863 19.1197ZM9.9731 56.053C9.92021 56.0597 9.8659 56.0636 9.81424 56.0636C9.18088 56.0636 8.63234 55.5919 8.55158 54.9482L6.00388 34.565C5.91642 33.8667 6.41189 33.2295 7.11013 33.1435C7.80573 33.0572 8.4442 33.5515 8.53166 34.2497L11.0794 54.6327C11.1668 55.331 10.6713 55.9682 9.9731 56.0544V56.053Z",
    fill: "url(#paint0_linear_5267_39210)"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.0427 17.2867C21.1695 17.2867 23.8112 19.5244 24.3253 22.6089L24.7108 24.93H43.3664C46.5911 24.93 49.3097 27.3439 49.6913 30.5434L50.0781 33.7694C51.819 33.4119 53.1266 31.8722 53.1266 30.0268V4.54678C53.1266 2.43636 51.415 0.724609 49.3044 0.724609H16.1827C14.0721 0.724609 12.3604 2.43495 12.3604 4.54678V17.2855H18.0401L18.0427 17.2867ZM47.3954 4.54819C48.4512 4.54819 49.3058 5.40407 49.3058 6.45866C49.3058 7.51325 48.45 8.36913 47.3954 8.36913C46.3406 8.36913 45.4849 7.51325 45.4849 6.45866C45.4849 5.40407 46.3406 4.54819 47.3954 4.54819ZM47.3954 12.1913C48.4512 12.1913 49.3058 13.0472 49.3058 14.1018C49.3058 15.1564 48.45 16.0122 47.3954 16.0122C46.3406 16.0122 45.4849 15.1564 45.4849 14.1018C45.4849 13.0472 46.3406 12.1913 47.3954 12.1913ZM28.9239 9.6436L39.1148 16.0136L28.9239 22.3835V9.6436Z",
    fill: "url(#paint1_linear_5267_39210)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5267_39210",
    x1: 32.7444,
    y1: 19.1143,
    x2: 32.7444,
    y2: 64.9761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#348BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#193861"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5267_39210",
    x1: 32.7435,
    y1: 0.724609,
    x2: 32.7435,
    y2: 33.7694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C73737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C1717"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5267_39210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary);
export default __webpack_public_path__ + "static/media/library.2b05c1fe0463df23452ecaef8b3d7f4d.svg";
export { ForwardRef as ReactComponent };